<template>
  <div
    class="visit-pill d-inline-flex align-items-center justify-content-center"
    title="Visitas al sitio"
    aria-live="polite"
    aria-atomic="true"
  >
    <svg class="me-2" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M12 5C5 5 1 12 1 12s4 7 11 7 11-7 11-7-4-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
    <span class="counter">{{ displayNumber }}</span>
    <span class="ms-2 label">visitas</span>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useVisitSession } from "@/modules/visitSession/stores/visitSession";

const total = ref(null);
const display = ref(0);
const store = useVisitSession();

const displayNumber = computed(() =>
  total.value == null ? "—" : Number(display.value).toLocaleString()
);

async function load() {
  const next = await store.get();
  if (total.value == null) { total.value = next; display.value = next; }
  else animateTo(next);
}

function animateTo(next) {
  const start = display.value, end = next;
  if (end === start) return;
  const duration = 800, t0 = performance.now();
  const step = (now) => {
    const t = Math.min(1, (now - t0) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    display.value = Math.round(start + (end - start) * eased);
    if (t < 1) requestAnimationFrame(step);
  };
  total.value = next;
  requestAnimationFrame(step);
}

onMounted(load);
</script>

<style scoped>
.visit-pill {
  padding: 0.75rem 1.75rem;
  border-radius: 2rem;
  background: linear-gradient(135deg, #d7f5e0, #e5fbe9);
  border: 2px solid #a7e3b4;
  color: #1b7f32;
  font-size: 1.25rem;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(27, 127, 50, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  user-select: none;
}
.visit-pill:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(27, 127, 50, 0.25); }
.counter { font-variant-numeric: tabular-nums; font-weight: 700; }
.label { font-weight: 500; color: #267a3f; }
@media (max-width: 576px) { .visit-pill { padding: 0.5rem 1.25rem; font-size: 1rem; } }
</style>
